<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
  <b-button @click="onSearch" variant="info">
      Buscar
  </b-button>
  </div>
  <b-modal :id="infoModal.id" size="xl" :title="infoModal.title" dialog-class="modal-search">
       <div class="modal-body">
          <form @submit.stop.prevent="searching">
              <b-row>
              <b-col>
              <b-form-group id="input-group-2"
              label="Ingrese fórmula a buscar:" label-for="input-2">
                  <div class="col-md-12 d-inline-flex align-items-center mb-5">
                    <b-form-input
                    id="input-2"
                    class="mr-2"
                    :state="($v.resoursetosearch.$dirty && submitted)? !$v.resoursetosearch.$error : null"
                    v-model.trim="resoursetosearch">
                    </b-form-input>
                    <b-button type="submit" size="md" variant="info">Buscar</b-button>
                  </div>

                  <b-table hover :items="resources"
                        :fields="fields"
                        sticky-header >
                <template v-slot:cell(actions)="row">
                  <b-button size="sm" variant="info"
                  @click="$emit('selected', row.item)"
                  >
                    Seleccionar
                  </b-button>
                </template>
                </b-table>
              </b-form-group>
              </b-col>
            </b-row>
          </form>
        </div>

        <template v-slot:modal-footer>
          <div class="col-md-12 d-flex justify-content-end mb-3">
            <b-button @click="onCreate" variant="success" class="p-2">
              <span> <i class="zmdi zmdi-plus"></i> Crear recurso</span>
            </b-button>
          </div>
        </template>

    </b-modal>
</div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';

export default {
  props: ['idModal'],
  data() {
    return {
      submitted: false,
      resoursetosearch: null,
      resources: [],
      itemSelected: {
        ID: null,
        NOMBRE: null,
        FORMULA: null,
      },
      fields: [
        { key: 'ID', label: 'ID' },
        { key: 'NOMBRE', label: 'Nombre' },
        { key: 'FORMULA', label: 'Fórmula' },
        { key: 'actions', label: 'Acciones', tdClass: 'tdActionClass' },
      ],
      infoModal: {
        id: this.idModal,
        title: 'Buscador de formulas',
      },
    };
  },
  validations: {
    resoursetosearch: {
      required,
      minLength: minLength(2),
    },
  },
  methods: {
    onSearch() {
      this.resources = [];
      this.resoursetosearch = null;
      this.itemSelected.ID = null;
      this.itemSelected.NOMBRE = null;
      this.itemSelected.FORMULA = null;
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    async searching() {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      this.resources = [];
      this.loading = true;
      const response = await this.axios.get('formula/searching', {
        params: {
          resoursetosearch: this.resoursetosearch,
        },
      });
      this.resources = response.data;
      this.loading = false;
    },
    onCreate() {
      const routeData = this.$router.resolve({ name: 'formulas' });
      window.open(routeData.href, '_blank');

      setTimeout(() => {
        const bc = new BroadcastChannel('new_resource_formula_open');
        bc.postMessage({});
      }, 500);
    },
  },
  mounted() {
    const self = this;
    const bc = new BroadcastChannel('new_resource_formula');
    bc.onmessage = (ev) => {
      self.resources.push(ev.data);
    };
  },
};
</script>
